import * as yup from 'yup';

import { getFormatMessage, getDateMessage } from 'utils/schema';

const defaultShape = {
  name: yup.string(),
  description: yup.string(),
  orbitalPosition: yup.string(),
  status: yup.string(),
  createdAt: yup.string(),
  updatedAt: yup.string(),
  archivedAt: yup.string(),
};
const yupSchema = yup.object().shape(defaultShape);

export const infosSchemaBlock = [
  {
    key: 'name',
    label: getFormatMessage,

    _form: {
      label: getFormatMessage,

      id: 'name',
      name: 'name',
      type: 'text',
    },
  },
  {
    key: 'description',
    label: getFormatMessage,

    _form: {
      label: getFormatMessage,

      id: 'description',
      name: 'description',
      type: 'text',
    },
  },
  {
    key: 'orbitalPosition',
    label: getFormatMessage,

    _form: {
      label: getFormatMessage,

      id: 'orbitalPosition',
      name: 'orbitalPosition',
      type: 'text',
    },
  },
  {
    key: 'createdAt',
    label: getFormatMessage,
    content: getDateMessage,
  },
  {
    key: 'status',
    // label: getFormatMessage,
  },
];

export default {
  yupSchema,
  blocks: [infosSchemaBlock],
};
